import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { Dialog, type DialogProps } from "./Dialog";
import { SquareButton, type SquareButtonKind } from "./buttons/SquareButton";

import { t } from "i18n/i18n";

type ConfirmationDialogProps = Omit<DialogProps, "children"> & {
  cancelButtonText?: string;
  cancelButtonKind?: SquareButtonKind;
  confirmButtonText?: string;
  confirmButtonKind?: SquareButtonKind;
  onConfirm?: () => void;
  reverseButtons?: boolean;
  children?: React.ReactNode;
};

export const ConfirmationDialog: FC<ConfirmationDialogProps> = ({
  onClose,
  children,
  cancelButtonText = t("common.cancel"),
  cancelButtonKind = "tertiary",
  confirmButtonText = t("common.confirm"),
  confirmButtonKind = "accent",
  onConfirm = () => {},
  reverseButtons = false,
  ...props
}) => (
  <Dialog {...props} onClose={onClose}>
    <>
      {children}

      <div
        className={twMerge(
          "mt-8 flex justify-end gap-2",
          reverseButtons && "flex-row-reverse justify-start",
        )}
      >
        <SquareButton
          eventName="Confirmation modal - Cancel"
          kind={cancelButtonKind}
          size="m"
          title={cancelButtonText}
          onClick={onClose}
        >
          {cancelButtonText}
        </SquareButton>

        <SquareButton
          eventName="Confirmation modal - Confirm"
          kind={confirmButtonKind}
          size="m"
          title={confirmButtonText}
          onClick={() => {
            onConfirm();
            onClose();
          }}
        >
          {confirmButtonText}
        </SquareButton>
      </div>
    </>
  </Dialog>
);
